let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("hz56j"), load("as7Oi"), load("9T4db"), load("43hsF"), load("i27dG")]).then(() => parcelRequire('8EC29'));